<div class="d-flex justify-content-between dialog-title">
  <div>
    <p class="mb-0 mt-1 dialog-title">Day End</p>
  </div>
  <div>
    <button type="button" mat-dialog-close mat-icon-button>
      <mat-icon class="dialog-icon">close</mat-icon>
    </button>
  </div>
</div>
<hr>

<form nz-form (ngSubmit)="onSubmit()" [formGroup]="dayEndFrom">
  <div mat-dialog-content>
    <nz-form-item>
      <div class="w-100">
        <nz-form-label nzRequired>Day End For</nz-form-label>
        <nz-form-control nzErrorTip="Day end for is required!">
          <nz-date-picker class="w-100" nzDisabled formControlName="dayEndFor" nzPlaceHolder="Day end for"
                          [nzDisabledDate]="disabledForDate"></nz-date-picker>
        </nz-form-control>
      </div>
    </nz-form-item>

    <nz-form-item>
      <div class="w-100">
        <nz-form-label nzRequired>Start Time</nz-form-label>
        <nz-form-control nzErrorTip="Closed time is required!">
          <nz-date-picker class="w-100" nzDisabled formControlName="restaurantStartedTime" nzPlaceHolder="Start time"
                          [nzShowTime]="{ nzFormat: 'HH:mm' }" nzFormat="yyyy-MM-dd HH:mm"
                          [nzDisabledDate]="disabledOpenDate"></nz-date-picker>
        </nz-form-control>
      </div>
    </nz-form-item>

    <nz-form-item>
      <div class="w-100">
        <nz-form-label nzRequired>Closed Time</nz-form-label>
        <nz-form-control nzErrorTip="Closed time is required!">
          <nz-date-picker class="w-100" formControlName="restaurantClosedTime" nzPlaceHolder="Closed time"
                          [nzShowTime]="{ nzFormat: 'HH:mm' }" nzFormat="yyyy-MM-dd HH:mm"
          [nzDisabledDate]="disabledBeforeAndAfter"></nz-date-picker>
        </nz-form-control>
      </div>
    </nz-form-item>

    <nz-form-item>
      <div class="w-100">
        <nz-form-label nzRequired>Day End Cash Amount <span class="text-danger ms-1">({{data.dailySession.startTime | date: 'yyyy/MM/dd'}} Amount)</span></nz-form-label>

        <nz-form-control nzErrorTip="Cash amount is required!">
          <nz-input-number class="w-100" nzId="dayEndCashAmount" formControlName="dayEndCashAmount" nzPlaceHolder="Day end cash amount"></nz-input-number>
        </nz-form-control>
      </div>
    </nz-form-item>

    <nz-form-item>
      <div class="w-100">
        <nz-form-label>Remark</nz-form-label>
        <nz-form-control>
          <textarea class="w-100" nz-input formControlName="dayEndRemark" placeHolder="remark"></textarea>
        </nz-form-control>
      </div>
    </nz-form-item>
  </div>

  <div class="mt-4 d-flex justify-content-end mb-4 me-4">
    <button type="button" class="small-btn-width btn-radius me-2" mat-dialog-close nzType="primary" nzGhost nz-button>
      Cancel
    </button>
    <button type="submit" nz-button nzType="primary" class="small-btn-width btn-radius">
      Submit
    </button>
  </div>
</form>
